import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamDeleteCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamDeleteCmd.validationSchema()
  );

  constructor(readonly value: RoomStreamToDeleteCmdRaw) {
    JsonSchemaValidator.assert(RoomStreamDeleteCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      }
    };
  }
}

interface RoomStreamToDeleteCmdRaw {
  roomId: RoomId;
  streamId: StreamId;
}
